import React, { useState } from 'react';

const PolicyModals = () => {
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalType) => {
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const styles = {
    container: {
      fontFamily: 'Merriweather, serif',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
    },
    linkContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      marginBottom: '30px',
    },
    link: {
      padding: '10px 15px',
      backgroundColor: '#4A90E2',
      color: 'white',
      borderRadius: '5px',
      textDecoration: 'none',
      fontWeight: 'bold',
      cursor: 'pointer',
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: 'white',
      padding: '30px',
      borderRadius: '10px',
      maxWidth: '800px',
      width: '90%',
      maxHeight: '80vh',
      overflowY: 'auto',
    },
    modalTitle: {
      color: '#333',
      marginBottom: '20px',
      textAlign: 'center',
    },
    closeButton: {
      backgroundColor: '#4A90E2',
      color: 'white',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontWeight: 'bold',
    },
    policyContent: {
      lineHeight: '1.6',
    },
    policyItem: {
      marginBottom: '15px',
    }
  };

  const termsContent = (
    <div style={styles.policyContent}>
      <h2 style={styles.modalTitle}>Terms & Conditions</h2>
      <ol>
        <li style={styles.policyItem}>We will confirm the hotel, cab, train and flight booking after receiving the advance/full payment.</li>
        <li style={styles.policyItem}>In case of given/mentioned hotel, cab, train or flight are sold out we will update you with the best similar options.</li>
        <li style={styles.policyItem}>In case of any natural disaster, strike, or any other external situation, bookings will be non refundable.</li>
        <li style={styles.policyItem}>Flight delays, food poisoning, getting sick unable to attend tour, natural calamity, strike etc. Under those circumstances, we agree to reschedule your start date with an additional charge of 50% of the total tour cost.</li>
        <li style={styles.policyItem}>Houseboat Air condition (AC) will be operated as per the houseboat policy. TripPro will not make any changes in the houseboat policy.</li>
        <li style={styles.policyItem}>Hot water will be provided as per the hotel/houseboat policy. TripPro will not make any changes in the hotel/houseboat policy.</li>
        <li style={styles.policyItem}>Hotel Standard check-in time is 2 PM and Standard Check-out time is 11 AM, Houseboat Standard check-in time is 1 PM and Standard check out time 9:30 AM, TripPro will only provide services which are mentioned in a written form on the TT portal.</li>
        <li style={styles.policyItem}>Cab driver will not carry any traveller luggage.</li>
        <li style={styles.policyItem}>Cab driver will provide service for 8-9 hours in a day.</li>
        <li style={styles.policyItem}>Late night/early morning pick up or drop service will include the night charge.</li>
        <li style={styles.policyItem}>Passport expiery date should be more then 7 months from the date of travel.</li>
        <li style={styles.policyItem}>Visa fees are non refundbale in case of rejection from authority.</li>
      </ol>
    </div>
  );

  const privacyContent = (
    <div style={styles.policyContent}>
      <h2 style={styles.modalTitle}>Booking Policy</h2>
      <ul>
        <li style={styles.policyItem}>Booking will be confirmed after paying the 30% advance of the total package price</li>
        <li style={styles.policyItem}>Booking of flight/train tickets will be made after receiving 100% flight amount</li>
      </ul>
    </div>
  );

  const cancellationContent = (
    <div style={styles.policyContent}>
      <h2 style={styles.modalTitle}>Cancellation Policy</h2>
      <ul>
        <li style={styles.policyItem}>Flight cancellation is based on the airline cancellation policy</li>
        <li style={styles.policyItem}>Land Package: 89 - 30 days prior to arrival date: 20% cancellation of the total land package amount.</li>
        <li style={styles.policyItem}>Land Package: 29 – 15 days prior to arrival date: 30% cancellation of the total land package amount.</li>
        <li style={styles.policyItem}>Land Package: 14 – 8 days prior to arrival date: 60% cancellation of the total land package amount.</li>
        <li style={styles.policyItem}>Land Package: 7 days prior to arrival date:100% cancellation of the total land package amount.</li>
        <li style={styles.policyItem}>Land Package: No show: 100% cancellation of the total land package amount.</li>
      </ul>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.linkContainer}>
        <a onClick={() => openModal('terms')} style={styles.link}>Terms & Conditions</a>
        <a onClick={() => openModal('privacy')} style={styles.link}>Booking Policy</a>
        <a onClick={() => openModal('cancellation')} style={styles.link}>Cancellation Policy</a>
      </div>

      {activeModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            {activeModal === 'terms' && termsContent}
            {activeModal === 'privacy' && privacyContent}
            {activeModal === 'cancellation' && cancellationContent}
            <button onClick={closeModal} style={{...styles.closeButton, marginTop: '20px', width: '100%'}}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PolicyModals;